import React, { ReactElement, useEffect, useState } from 'react';
import { LandingContent } from '@components/landing/LandingContent';
import { LandingFooter } from '@components/landing/LandingFooter';
import { Layout } from 'antd';
import { DARKBG_PATHS } from '@mock/ThemeSettings';
import { UserType } from '@pages/dashboard/SignUp/SignUp';
import { setToken } from '@store/auth';
import { Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ProfileLogoHeader from '@components/profile/ProfileLogoHeader';
import ProfileHeader from '@components/profile/ProfileHeader';

interface ProfileLayoutProps {
  type: UserType;
}

const ProfileLayout: React.FC<ProfileLayoutProps> = ({ type }): ReactElement => {
  const [isLogged, setIsLogged] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isBgDark = DARKBG_PATHS.includes(pathname);

  useEffect(() => {
    const checkIsAuth = async () => {
      try {
        const user = await Auth.currentSession();
        const accessToken = user.getIdToken();
        const token = accessToken.getJwtToken();
        if (user) {
          dispatch(setToken({ token }));
          setIsLogged(true);
          const userType = localStorage.getItem('userType');
          if (userType === UserType.POLICYHOLDER) {
            navigate('/dashboard/profile');
          } else if (userType !== type) {
            navigate(type === UserType.PRODUCER ? '/producer-profile' : '/affiliate-profile');
          }
        }
      } catch (error) { }
    };
    checkIsAuth().then();
  }, [dispatch, navigate, type]);

  const isPlaceNewPolicyPath = pathname === '/place-new-policy';
  const isSetupPath = pathname === '/setup-producer'

  return (
    <Layout
      className="flex flex-col"
      style={{
        background: `transparent linear-gradient(${isBgDark
          ? '1deg, #2674BA 0%, #08204D 100%'
          : '0deg, #59DFE540 0%, #59DFE500 100%'
          }) 0% 0% no-repeat padding-box`,
      }}
    >
      {(isPlaceNewPolicyPath || isSetupPath) ? <ProfileLogoHeader type={type} /> : <ProfileHeader type={type} />}
      <LandingContent>
        {isLogged && <Outlet />}
      </LandingContent>
      <LandingFooter />
    </Layout>
  );
};

export default ProfileLayout; 